<input
  #searchInput
  [placeholder]="placeholder"
  type="text"
  matInput
  [matAutocomplete]="auto"
  (input)="handleSearchTermInput()"
  (focus)="handleSearchTermInput()"
  [formControl]="searchCtrl"
/>
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" requireSelection>
  <mat-option *ngFor="let option of options$ | async" [value]="option">
    {{ option?.displayName }}
  </mat-option>
</mat-autocomplete>
